
export default {
  name: "GrupoEmpresaAuditoria",
  data() {
    const hoje = new Date();
    const inicio = new Date(hoje);
    inicio.setDate(inicio.getDate() - 30);

    return {
      carregandoInicial: true,
      carregando: false,
      grupo: null,
      registros: [],
      filtros: {
        acao: "",
        inicio: this.formatarDataInput(inicio),
        fim: this.formatarDataInput(hoje),
      },
      paginacao: {
        current_page: 1,
        last_page: 1,
        per_page: 25,
        total: 0,
      },
      opcoesAcao: [
        { value: "", text: "Todos os eventos" },
        { value: "TROCA_EMPRESA", text: "Troca de empresa" },
        {
          value: "EMPRESA_PADRAO_ALTERADA",
          text: "Empresa padrão alterada",
        },
        {
          value: "ACESSO_USUARIO_ALTERADO",
          text: "Acesso de usuário alterado",
        },
        {
          value: "CADASTROS_COPIADOS",
          text: "Cadastros copiados",
        },
      ],
    };
  },
  methods: {
    formatarDataInput(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    formatarDataHora(valor) {
      if (!valor) return "—";
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(valor));
    },
    nomeEmpresa(empresa) {
      return empresa?.nome_fantasia || empresa?.nome || "Empresa não informada";
    },
    nomeEmpresaPorId(id) {
      const membro = (this.grupo?.membros || []).find(
        (item) => Number(item.id_empresa) === Number(id)
      );
      return membro ? this.nomeEmpresa(membro.empresa) : `Empresa ${id}`;
    },
    labelAcao(acao) {
      return (
        this.opcoesAcao.find((opcao) => opcao.value === acao)?.text || acao
      );
    },
    labelEscopo(escopo, empresas = []) {
      const labels = {
        SOMENTE_EMPRESA: "Somente matriz",
        EMPRESAS_SELECIONADAS: "Empresas selecionadas",
        TODO_GRUPO: "Todo o grupo",
      };
      const nomes = empresas.map(this.nomeEmpresaPorId).join(", ");
      return `${labels[escopo] || escopo}${nomes ? ` (${nomes})` : ""}`;
    },
    descricaoRegistro(registro) {
      if (registro.acao === "ACESSO_USUARIO_ALTERADO") {
        const antes = registro.detalhes?.antes || {};
        const depois = registro.detalhes?.depois || {};
        const usuario = registro.usuario_afetado?.nome || "Usuário";
        return `${usuario}: ${this.labelEscopo(
          antes.escopo_acesso,
          antes.empresas
        )} → ${this.labelEscopo(depois.escopo_acesso, depois.empresas)}`;
      }

      if (registro.acao === "CADASTROS_COPIADOS") {
        const detalhes = registro.detalhes || {};
        const modulos = {
          UNIDADE_MEDIDA: "Unidades de medida",
          GRUPO: "Grupos",
          TRIBUTACAO: "Tributações",
          NATUREZA: "Naturezas",
          PERFIL_TRIBUTARIO: "Perfis tributários",
          PESSOA: "Pessoas",
          PRODUTO: "Produtos",
        };
        return `${modulos[detalhes.modulo] || detalhes.modulo}: ${
          detalhes.criados || 0
        } copiado(s), ${
          detalhes.existentes || 0
        } já existente(s) — ${this.nomeEmpresa(
          registro.empresa_origem
        )} → ${this.nomeEmpresa(registro.empresa_destino)}`;
      }

      return `${this.nomeEmpresa(registro.empresa_origem)} → ${this.nomeEmpresa(
        registro.empresa_destino
      )}`;
    },
    aplicarFiltros() {
      this.paginacao.current_page = 1;
      this.carregarAuditoria();
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          await this.carregarAuditoria();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarAuditoria() {
      if (!this.grupo?.id_grupo_empresa) return;
      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/auditoria`,
          {
            params: {
              acao: this.filtros.acao || undefined,
              inicio: this.filtros.inicio || undefined,
              fim: this.filtros.fim || undefined,
              page: this.paginacao.current_page,
              per_page: this.paginacao.per_page,
            },
          }
        );
        this.registros = data?.data || [];
        this.paginacao = {
          ...this.paginacao,
          ...(data?.meta || {}),
        };
      } finally {
        this.carregando = false;
      }
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
